import { RadioGroup, Flex, Box, Checkbox } from "@chakra-ui/react";
import { DroppableBox } from "components/containers/InspectionFormat/containers/LayoutFrameBuilder";
import { SOURCE } from "components/containers/InspectionFormat/Content/SettingPinLayoutFrame/context/pinLayoutFrameReducer";
import FieldCheckboxPreviewWrapper from "../../../components/FieldCheckboxPreviewWrapper";
import { CheckboxPreviewerProps } from "../previewer";
import CheckboxIcon from "components/icon/CheckboxIcon";
import React from "react";
import TyphographyIcon from "components/icon/TyphographyIcon";
import { transformCheckboxExtraKey } from "models/pinFrame";

export enum CheckboxExtraKey {
  VALUE = "value",
  LABEL = "label",
}

interface DraggableProps extends CheckboxPreviewerProps {
  additionInfoCheckbox: any[];
}

const Draggable: React.FC<DraggableProps> = ({
  item,
  value,
  isReadOnly,
  additionInfoCheckbox,
  index,
  prevItemResultCount,
  allItemResultCount,
  onChange,
}) => {
  return (
    <FieldCheckboxPreviewWrapper
      title={item.name}
      data-type={item.dataType}
      index={index}
      prevItemResultCount={prevItemResultCount}
      allItemResultCount={allItemResultCount}
    >
      <RadioGroup value={value} onChange={onChange}>
        <Flex
          display={"flex"}
          flexWrap={"wrap"}
          gap="1rem"
          justifyContent={"space-between"}
          pr="2rem"
        >
          {additionInfoCheckbox.map((data, index) => {
            const { normalizeCheckboxValue, normalizeCheckboxLabel } =
              transformCheckboxExtraKey(index);

            return (
              <Flex alignItems={"center"} gap={"1rem"} key={index}>
                <DroppableBox
                  name={data.displayValue}
                  icon={<CheckboxIcon w="3rem" h="3rem" />}
                  id={item.id}
                  extraId={normalizeCheckboxValue}
                  source={SOURCE.INSPECTION_FORM}
                >
                  <Box className="draggable-area" w="100%" p="0.5rem 1rem">
                    <Checkbox
                      isReadOnly={isReadOnly}
                      width="fit-content"
                      value={data.displayValue}
                    />
                  </Box>
                </DroppableBox>
                <DroppableBox
                  name={data.displayValue}
                  icon={<TyphographyIcon w="3rem" h="3rem" />}
                  id={item.id}
                  extraId={normalizeCheckboxLabel}
                  source={SOURCE.INSPECTION_FORM}
                >
                  <Box className="draggable-area" w="100%" p="0.5rem 0rem">
                    {data.displayValue}
                  </Box>
                </DroppableBox>
              </Flex>
            );
          })}
        </Flex>
      </RadioGroup>
    </FieldCheckboxPreviewWrapper>
  );
};

export default Draggable;
